import axios from 'axios'
import {router} from '../routes'

// https://medium.com/techvblogs/spa-authentication-using-laravel-sanctum-and-vue-js-6f81b6410a2b

export default {
    namespaced: true,
    state: {
        authenticated: false,
        user: {} // les commandes se trouvent dans l'objet user
    },
    getters: {
        authenticated: (state) => {
            return state.authenticated
        },
        user(state) {
            return state.user
        }
    },
    mutations: {
        SET_AUTHENTICATED(state, value) {
            state.authenticated = value
        },
        SET_USER(state, value) {
            state.user = value
        },
        updateUserCommande(state, commande) {
            const index = state.user.commandes.findIndex(c => c.id === commande.id);
            state.user.commandes.splice(index, 1, commande);
        },
    },
    actions: {
        // par défaut, on redirige vers le compte, sinon envoyer "false" pour rester sur la même page sans rediriger (utile si le login est dans un menu)
        login({commit, dispatch}, redirect = {name: 'compte'}) {
            return axios.get('/api/user')
                .then(({data}) => {
                    commit('SET_USER', data.data)
                    commit('SET_AUTHENTICATED', true)
					// Met a jour le supplément de livraison après login
					// TODO: voir si on peut pas mettre ca ailleurs...
					dispatch('panier/updateSupplementLivraison', data.data.code_postal, { root: true })
                    if (redirect)
                        router.push(redirect)
                })
                .catch(({response: {data}}) => {
                    commit('SET_USER', {})
                    commit('SET_AUTHENTICATED', false)
                })
        },
        async register(context, newUser) {
            const user = (await axios.post(`/api/register`, newUser)).data.data;
        },
        logout({commit}) {
            commit('SET_USER', {})
            commit('SET_AUTHENTICATED', false)
        },
        async saveProfil(context, dataUser) {
            const user = {...dataUser} // On clone l'objet pour pouvoir supprimer les commandes afin que la requête ne soit pas trop lourde
            delete user.commandes;
            const res = (await axios.put(`api/users/${user.id}`, user)).data.data;
            context.commit('SET_USER', res);
        },
        async updateUserCommande(context, commande_id) {
            const commande = (await axios.get(`/api/commandes/${commande_id}`)).data.data;
            if(commande) {
                context.commit('updateUserCommande', commande);
            }
        }
    },
};
